/** Короткий заголовок для верхней панели (без подзаголовка, одна строка). */
export function pageTitleFromPath(pathname: string, search?: string): string {
  const p = pathname.replace(/\/$/, '') || '/'

  if (p === '/tickets') return 'Все обращения'
  if (/^\/tickets\/.+/.test(p)) return 'Обращение'
  if (p === '/ai-tickets') return 'Мозгобот'
  if (p === '/dashboard') return 'Дашборд'
  if (p === '/analytics') return 'Аналитика'
  if (p === '/analytics-new') return 'Аналитика New'
  if (p === '/bookmarks') return 'Закладки'
  if (p === '/filters') return 'Фильтры'
  if (p === '/reviews') return 'Оценки и отзывы'
  if (p === '/quality') return 'АРМ Качества'
  if (p === '/failed-deliveries') return 'Отладка · Недоставленные'
  if (p === '/debug') {
    const sp = search?.trim()
    if (sp) {
      const q = sp.startsWith('?') ? sp.slice(1) : sp
      const tab = new URLSearchParams(q).get('tab')
      if (tab === 'failed-deliveries') return 'Отладка · Недоставленные'
    }
    return 'Отладка'
  }
  if (p === '/installers') return 'Установщики'
  if (p === '/users') return 'Пользователи'
  if (p === '/operators') return 'Операторы'
  if (p === '/operator/quick-settings') return 'Быстрые настройки'
  if (p === '/schedules') {
    const sp = search?.trim()
    if (sp) {
      const q = sp.startsWith('?') ? sp.slice(1) : sp
      const tab = new URLSearchParams(q).get('tab')
      if (tab === 'analysis') return 'Табель · Анализ'
    }
    return 'Табель'
  }
  if (p === '/emergency-mode') return 'Аварийный режим'
  if (p === '/settings') return 'Настройки'
  if (p === '/knowledge-base') return 'База знаний'
  if (p === '/anomalies') return 'Аномалии'
  if (p === '/actualization') return 'Актуализация'
  if (p === '/activity-log') return 'Лог действий'
  if (p === '/profile') return 'Личный кабинет'
  if (p === '/ai-audit-log') return 'AI аудит'
  if (/^\/projects\/[^/]+\/ai-assistant$/.test(p)) return 'AI ассистент проекта'

  return 'Servicedesk'
}
